<ng-container *ngIf="measureCards.length > 0">

  <ng-container *ngIf="viewModel$ | async as vm">

    <div class="is-flex is-column">
      <div [class.selected]="vm.selected"
        class="measure-card-parent is-flex gap-8 is-cursor-pointer bg-blue-hover-5 bg-transition"
        (click)="selectCards(vm.selected)">
        <app-icon [name]="icon" class="text-32"></app-icon>
        <app-text class="text-14 is-family-semiBold">{{ label | AsyncLang | async }}</app-text>
      </div>
      <div class="measure-cards-container" *ngIf="measureCards.length > 1">
        <ng-content></ng-content>
      </div>
    </div>

  </ng-container>

</ng-container>
